module.exports = __webpack_public_path__ + "img/screen-write-en.b60a6afa.png";